<div class="video-manager">
  <mat-spinner 
    *ngIf="!ready" 
    diameter="40"
  />

  <!-- Tabella -->
  <div *ngIf="videos.length > 0; else addFirstVideo">
    <h2 >VIDEOS</h2>
    <table class="video-table">
      <thead>
        <tr>
          <th>#</th>
          <th>YouTube URL</th>
          <th>Title</th>
          <th>Description</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let video of videos; let i = index">
          <td class="order">
            <span class="num">
              {{ i + 1 }}
            </span>
            <input type="checkbox" name="on" [checked]="video.on" >
          </td>
          <td class="url-cell" title="{{ video.url }}">{{ video.url }}</td>
          <td>{{ video.title }}</td>
          <td>{{ video.description }}</td>
          <td class="action-buttons">
            <button (click)="editRecord(i)">
              <mat-icon>edit</mat-icon>
            </button>
            <button (click)="removeRecord(i)">
              <mat-icon>delete</mat-icon>
            </button>
            <button (click)="reorderRecord(i, 'up')" [disabled]="i === 0">
              <mat-icon>arrow_upward_alt</mat-icon>
            </button>
            <button (click)="reorderRecord(i, 'down')" [disabled]="i === videos.length - 1">
              <mat-icon>arrow_downward_alt</mat-icon>
            </button>
            <button (click)="addRecord(i)">
              <mat-icon>add</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <ng-template #addFirstVideo>
    <div
      class="add-first-video"
      (click)="addRecord(-1)"
    >
      ADD A VIDEO
    </div>
  </ng-template>
  
</div>